export interface HubspotStatusResponse {
  connected: boolean;
  portal_id?: string;
  bulk_completed_at?: string | null;
  last_webhook_received_at?: string | null;
  total_objects_synced?: number;
  purpose?: 'import_only' | 'sync';
}

export interface HubspotFieldMapping {
  id: number;
  object_type: 'contact' | 'company' | 'deal';
  ahoy_property: string | null;
  external_property: string;
  hubspot_field_type: string;
  sync_direction:
    | 'bidirectional'
    | 'ahoy_to_external'
    | 'external_to_ahoy'
    | 'skipped';
  conflict_resolution: 'ahoy_wins' | 'external_wins' | 'most_recent' | null;
  is_required_in_hubspot: boolean;
}

export interface HubspotFieldMappingsResponse {
  mappings: HubspotFieldMapping[];
}

export interface HubspotSyncHealthError {
  id: number;
  entity_id: string;
  operation: string;
  attempt_count: number;
  last_error: string;
  next_attempt_at: string | null;
}

export interface HubspotSyncHealthResponse {
  connected: boolean;
  last_webhook_received_at?: string | null;
  outbound?: {
    pending: number;
    failing: number;
    permanently_failed?: number;
    errors: HubspotSyncHealthError[];
  };
  inbound?: { pending: number };
  skipped_field_count?: number;
  webhook_stale?: boolean;
  webhook_stale_detected_at?: string | null;
}

export interface HubspotInstallResponse {
  url: string;
}

export interface HubspotConnectionSettings {
  default_sync_direction: 'bidirectional' | 'inbound_only' | 'outbound_only';
  propagate_outbound_deletes: boolean;
}

export interface AhoyPropertyOption {
  name: string;
  label: string;
}

export const HUBSPOT_OBJECT_TYPES = [
  { id: 'contact', label: 'Contacts', entityType: 'ahoy_contact' },
  { id: 'company', label: 'Companies', entityType: 'ahoy_company' },
  { id: 'deal', label: 'Deals', entityType: 'ahoy_deal' },
] as const;

export type HubspotObjectType = (typeof HUBSPOT_OBJECT_TYPES)[number]['id'];

export type StageDrift = 'ok' | 'renamed' | 'archived' | 'unmapped';

export interface PipelineStageMappingRow {
  ahoy_entity_id: string | null;
  ahoy_name: string | null;
  ahoy_order: number | null;
  hubspot_stage_id: string | null;
  hubspot_label: string | null;
  drift: StageDrift;
}

export interface PipelineMappingReport {
  ahoy_entity_id: string | null;
  ahoy_name: string | null;
  hubspot_pipeline_id: string;
  hubspot_label: string | null;
  stages: PipelineStageMappingRow[];
}

export interface PipelineStageMappingsResponse {
  pipelines: PipelineMappingReport[];
}
